// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TournamentsTab_container__n06Fi {
  position: relative;
  margin-top: 60px;
}
.TournamentsTab_container__n06Fi::before {
  content: "";
  display: block;
  width: 100%;
  height: 16px;
  background: #000000;
  position: absolute;
  bottom: calc(100% + 20px);
  left: 0;
  border-radius: 12px;
}
.TournamentsTab_container__n06Fi .TournamentsTab_tournamentsWrapper__cAW0t {
  overflow-x: clip;
}
.TournamentsTab_container__n06Fi .TournamentsTab_customNavigation__xU0w0 {
  display: flex;
  justify-content: space-between;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translateY(-50%);
  z-index: 10;
  pointer-events: none;
}
.TournamentsTab_container__n06Fi .TournamentsTab_customNavigation__xU0w0 .TournamentsTab_prevButton__SDeZA,
.TournamentsTab_container__n06Fi .TournamentsTab_customNavigation__xU0w0 .TournamentsTab_nextButton__LM6-9 {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  pointer-events: auto;
  margin: 0 -20px;
}
.TournamentsTab_container__n06Fi .TournamentsTab_customNavigation__xU0w0 .TournamentsTab_prevButton__SDeZA svg path,
.TournamentsTab_container__n06Fi .TournamentsTab_customNavigation__xU0w0 .TournamentsTab_nextButton__LM6-9 svg path {
  fill: #292621;
}
.TournamentsTab_container__n06Fi .TournamentsTab_customNavigation__xU0w0 .TournamentsTab_nextButton__LM6-9 {
  transform: rotate(180deg);
}
.TournamentsTab_container__n06Fi .TournamentsTab_swiper__rGjO0 {
  overflow: unset;
  padding-right: 10px;
}
.TournamentsTab_container__n06Fi .TournamentsTab_tournament__Xw40y {
  background: #000000;
  width: 150px;
  border-radius: 12px;
  padding-top: 16px;
  padding-left: 8px;
  padding-right: 8px;
  height: 200px;
  position: relative;
}
.TournamentsTab_container__n06Fi .TournamentsTab_tournament__Xw40y.TournamentsTab_active__53OIn {
  box-shadow: 0px 0px 12.5px -1px rgb(248, 255, 19);
  border: 1px solid #F2F740;
}
.TournamentsTab_container__n06Fi .TournamentsTab_tournament__Xw40y.TournamentsTab_active__53OIn .TournamentsTab_tournamentLogo__0QTVc img {
  opacity: 1;
}
.TournamentsTab_container__n06Fi .TournamentsTab_tournament__Xw40y.TournamentsTab_active__53OIn .TournamentsTab_tournamentName__CtdPR {
  font-weight: 600;
  font-size: 14px;
  color: #FAF9F8;
  margin-top: 30px;
  text-align: center;
}
.TournamentsTab_container__n06Fi .TournamentsTab_tournament__Xw40y.TournamentsTab_active__53OIn .TournamentsTab_tournamentDates__6-k4f {
  font-size: 14px;
  font-weight: 400;
  color: #C2BDB2;
  margin-top: 8px;
  text-align: center;
}
.TournamentsTab_container__n06Fi .TournamentsTab_tournament__Xw40y.TournamentsTab_completed__kh93s {
  box-shadow: 0px 0px 12.5px -1px rgba(0, 158, 105, 0.2509803922);
  border: 1px solid #009E69;
}
.TournamentsTab_container__n06Fi .TournamentsTab_tournament__Xw40y .TournamentsTab_tournamentLogo__0QTVc {
  display: flex;
  justify-content: center;
  align-items: center;
}
.TournamentsTab_container__n06Fi .TournamentsTab_tournament__Xw40y .TournamentsTab_tournamentLogo__0QTVc img {
  height: 84px;
  width: 84px;
  opacity: 0.6;
}
.TournamentsTab_container__n06Fi .TournamentsTab_tournament__Xw40y .TournamentsTab_tournamentName__CtdPR {
  font-weight: 600;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.3019607843);
  margin-top: 30px;
  text-align: center;
}
.TournamentsTab_container__n06Fi .TournamentsTab_tournament__Xw40y .TournamentsTab_tournamentDates__6-k4f {
  font-size: 14px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.3019607843);
  margin-top: 8px;
  text-align: center;
  position: absolute;
  bottom: 8px;
  left: 0;
  right: 0;
}
.TournamentsTab_container__n06Fi .TournamentsTab_tournament__Xw40y .TournamentsTab_tournamentStatus__jDUu- {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  left: 0;
  right: 0;
  bottom: 110%;
}`, "",{"version":3,"sources":["webpack://./src/pages/Cybermarathon/components/TournamentsTab/TournamentsTab.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,gBAAA;AACF;AACE;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,OAAA;EACA,mBAAA;AACJ;AAEE;EACE,gBAAA;AAAJ;AAGE;EACE,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,2BAAA;EACA,WAAA;EACA,oBAAA;AADJ;AAGI;;EAEE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,oBAAA;EACA,eAAA;AADN;AAIQ;;EACE,aAAA;AADV;AAMI;EACE,yBAAA;AAJN;AAQE;EACE,eAAA;EACA,mBAAA;AANJ;AASE;EACE,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;AAPJ;AASI;EACE,iDAAA;EACA,yBAAA;AAPN;AAUQ;EACE,UAAA;AARV;AAYM;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AAVR;AAaM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AAXR;AAeI;EACE,+DAAA;EACA,yBAAA;AAbN;AAgBI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAdN;AAgBM;EACE,YAAA;EACA,WAAA;EACA,YAAA;AAdR;AAkBI;EACE,gBAAA;EACA,eAAA;EACA,wCAAA;EAEA,gBAAA;EACA,kBAAA;AAjBN;AAoBI;EACE,eAAA;EACA,gBAAA;EACA,wCAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;AAlBN;AAqBI;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;AAnBN","sourcesContent":[".container {\n  position: relative;\n  margin-top: 60px;\n\n  &::before {\n    content: \"\";\n    display: block;\n    width: 100%;\n    height: 16px;\n    background: #000000;\n    position: absolute;\n    bottom: calc(100% + 20px);\n    left: 0;\n    border-radius: 12px;\n  }\n\n  .tournamentsWrapper {\n    overflow-x: clip;\n  }\n\n  .customNavigation {\n    display: flex;\n    justify-content: space-between;\n    position: absolute;\n    top: 50%;\n    width: 100%;\n    transform: translateY(-50%);\n    z-index: 10;\n    pointer-events: none;\n\n    .prevButton,\n    .nextButton {\n      width: 36px;\n      height: 36px;\n      border-radius: 50%;\n      background: #FFFFFF;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      cursor: pointer;\n      pointer-events: auto;\n      margin: 0 -20px;\n\n      svg {\n        path {\n          fill: #292621;\n        }\n      }\n    }\n\n    .nextButton {\n      transform: rotate(180deg);\n    }\n  }\n\n  .swiper {\n    overflow: unset;\n    padding-right: 10px;\n  }\n\n  .tournament {\n    background: #000000;\n    width: 150px;\n    border-radius: 12px;\n    padding-top: 16px;\n    padding-left: 8px;\n    padding-right: 8px;\n    height: 200px;\n    position: relative;\n\n    &.active {\n      box-shadow: 0px 0px 12.5px -1px rgba(248, 255, 19, 1);\n      border: 1px solid #F2F740;\n\n      .tournamentLogo {\n        img {\n          opacity: 1;\n        }\n      }\n\n      .tournamentName {\n        font-weight: 600;\n        font-size: 14px;\n        color: #FAF9F8;\n        margin-top: 30px;\n        text-align: center;\n      }\n\n      .tournamentDates {\n        font-size: 14px;\n        font-weight: 400;\n        color: #C2BDB2;\n        margin-top: 8px;\n        text-align: center;\n      }\n    }\n\n    &.completed {\n      box-shadow: 0px 0px 12.5px -1px #009E6940;\n      border: 1px solid #009E69;\n    }\n\n    .tournamentLogo {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n\n      img {\n        height: 84px;\n        width: 84px;\n        opacity: 0.6;\n      }\n    }\n\n    .tournamentName {\n      font-weight: 600;\n      font-size: 14px;\n      color: #FFFFFF4D;\n\n      margin-top: 30px;\n      text-align: center;\n    }\n\n    .tournamentDates {\n      font-size: 14px;\n      font-weight: 400;\n      color: #FFFFFF4D;\n      margin-top: 8px;\n      text-align: center;\n      position: absolute;\n      bottom: 8px;\n      left: 0;\n      right: 0;\n    }\n\n    .tournamentStatus {\n      position: absolute;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      left: 0;\n      right: 0;\n      bottom: 110%;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `TournamentsTab_container__n06Fi`,
	"tournamentsWrapper": `TournamentsTab_tournamentsWrapper__cAW0t`,
	"customNavigation": `TournamentsTab_customNavigation__xU0w0`,
	"prevButton": `TournamentsTab_prevButton__SDeZA`,
	"nextButton": `TournamentsTab_nextButton__LM6-9`,
	"swiper": `TournamentsTab_swiper__rGjO0`,
	"tournament": `TournamentsTab_tournament__Xw40y`,
	"active": `TournamentsTab_active__53OIn`,
	"tournamentLogo": `TournamentsTab_tournamentLogo__0QTVc`,
	"tournamentName": `TournamentsTab_tournamentName__CtdPR`,
	"tournamentDates": `TournamentsTab_tournamentDates__6-k4f`,
	"completed": `TournamentsTab_completed__kh93s`,
	"tournamentStatus": `TournamentsTab_tournamentStatus__jDUu-`
};
export default ___CSS_LOADER_EXPORT___;
